import { SPM_API } from '../baseURL'
import axios from '../config'

const schoolGuid = '96e873b3-ac6f-02f7-4c78-f2f7485a7145';

export default {
  //获取数字教材栏目
  getDigitalBookColumn() {
    return axios.get(`${SPM_API}/digitalColumn/list?fk_school_id=${schoolGuid}`)
  },
}